export default __webpack_public_path__ + "assets/fonts/ClanPro-Medium.fbafa32370ca8801062e609a27bd0ee4.otf";